import request from '@/utils/request'

// 查询叫料单管理列表
export function apiScpCallManagerList (data) {
  return request({
    url: '/scp/scpCallManager/list',
    method: 'post',
    data: data
  })
}

// 更新叫料数据
export function apiUpdateCallDemand (data) {
  return request({
    url: `/scp/scpCallManager/updateCallQty`,
    method: 'post',
    data: data
  })
}

// 五金清空叫料通知
export function apiScpClearCallNotify (data) {
  return request({
    url: `/scp/scpCallManager/clearCallNotify`,
    method: 'post',
    data: data
  })
}

// 皮布清空叫料通知
export function apiScpClearFabricCoverCallNotify (data) {
  return request({
    url: `/scp/scpCallManager/clearFabricCoverCallNotify`,
    method: 'post',
    data: data
  })
}

// 更新叫料需求字段
export function apiScpCallManagerUpdate (data) {
  return request({
    url: `/scp/scpCallManager/update`,
    method: 'post',
    data: data
  })
}

// 查询叫料通知列表
export function apiListCallNotify (query) {
  return request({
    url: '/scp/scpCallManager/listCallNotify',
    method: 'get',
    params: query
  })
}

// 创建叫料通知（五金）
export function apiListHardwareCallNotify (data) {
  return request({
    url: '/scp/scpCallManager/listHardwareCallNotify',
    method: 'post',
    data: data
  })
}

// 创建叫料通知（皮布套）
export function apiListFabricCoverCallNotify (data) {
  return request({
    url: '/scp/scpCallManager/listFabricCoverCallNotify',
    method: 'post',
    data: data
  })
}

// 导出叫料通知
export function apiExportCallNotice (data) {
  return request({
    url: '/scp/scpCallManager/exportCallNotice',
    method: 'post',
    data: data
  })
}

// 获取汇总数量
export function apiSumCallManagerQty (data) {
  return request({
    url: '/scp/scpCallManager/sumCallManagerQty',
    method: 'post',
    data: data
  })
}

// 下推叫料通知
export function apiPushCallNotice (data) {
  return request({
    url: '/scp/scpCallManager/pushCallNotice',
    method: 'post',
    data: data
  })
}

// 批量修改叫料标识
export function apiBatchUpdateCallFlag (data) {
  return request({
    url: `/scp/scpCallManager/batchUpdateCallFlag`,
    method: 'post',
    data: data
  })
}

// 导出工单叫料
export function apiExportCallManager (data) {
  return request({
    url: `/scp/scpCallManager/exportCallManager`,
    method: 'post',
    data: data
  })
}

// 五金更新叫料通知
export function apiUpdateCallNoticeWj (data) {
  return request({
    url: `/scp/scpCallManager/updateCallNoticeWj`,
    method: 'post',
    data: data
  })
}

// 更新叫料通知
export function apiUpdateCallNotice (data) {
  return request({
    url: `/scp/scpCallManager/updateCallNotice`,
    method: 'post',
    data: data
  })
}

// 刷新可叫料数
export function apiWorkOrderRefreshCanCallQty (data) {
  return request({
    url: `/scp/scpCallManager/refreshCanCallQty`,
    method: 'post',
    data: data
  })
}

// 查询工厂暂存详情
export function apiListFactoryTemp (query) {
  return request({
    url: '/scp/scpCallManager/listFactoryTemp',
    method: 'get',
    params: query
  })
}

// 查询bom备注下拉
export function apiBomRemarkComboBox (query) {
  return request({
    url: '/scp/scpCallManager/bomRemarkComboBox',
    method: 'get',
    params: query
  })
}
